import { Expose, Transform } from 'class-transformer';
import { Model } from './model';
import { MonthlyDashboardReports } from './monthly-dashboard-reports';
import { deleteObjectProperties } from 'src/app/shared/helper';

export class DashboardReportsCharts extends Model {
  /* students */
  @Expose({ name: 'activeOnAppStudentCountFemale' }) countOfOnlineFemaleStudents: number;
  @Expose({ name: 'activeOnAppStudentCountMale' }) countOfOnlineMaleStudents: number;
  @Expose({ name: 'activeStudentCountFemale' }) countOfActiveFemaleStudents: number;
  @Expose({ name: 'activeStudentFemaleChangeRate' }) changeRateOfActiveFemaleStudents: number;
  @Expose({ name: 'activeStudentCountMale' }) countOfActiveMaleStudents: number;
  @Expose({ name: 'activeStudentMaleChangeRate' }) changeRateOfActiveMaleStudents: number;
  @Expose({ name: 'blockedStudentCountFemale' }) countOfBlockedFemaleStudents: number;
  @Expose({ name: 'blockedStudentCountMale' }) countOfBlockedMaleStudents: number;
  @Expose({ name: 'busyStudentCountMale' }) countOfBusyMaleStudents: number;
  @Expose({ name: 'busyStudentCountFemale' }) countOfBusyFemaleStudents: number;
  /* teachers */
  @Expose({ name: 'activeTeacherCountFemale' }) countOfActiveFemaleTeachers: number;
  @Expose({ name: 'activeTeacherFemaleChangeRate' }) changeRateOfActiveFemaleTeachers: number;
  @Expose({ name: 'activeTeacherCountMale' }) countOfActiveMaleTeachers: number;
  @Expose({ name: 'activeTeacherMaleChangeRate' }) changeRateOfActiveMaleTeachers: number;
  @Expose({ name: 'blockedTeacherCountFemale' }) countOfBlockedFemaleTeachers: number;
  @Expose({ name: 'blockedTeacherCountMale' }) countOfBlockedMaleTeachers: number;
  @Expose({ name: 'onlineTeachersCountFemale' }) countOfOnlineFemaleTeachers: number;
  @Expose({ name: 'onlineTeachersCountMale' }) countOfOnlineMaleTeachers: number;
  @Expose({ name: 'busyTeacherCountMale' }) countOfBusyMaleTeachers: number;
  @Expose({ name: 'busyTeacherCountFemale' }) countOfBusyFemaleTeachers: number;
  /*  */
  @Expose()
  @Transform(({ obj }) =>
    obj && obj.invoiceReport
      ? obj.invoiceReport.map((item) => {
          item['totalCount'] = item.totalcount;
          item['totalRetrieved'] = item.succeededCount;
          deleteObjectProperties(item, ['totalcount', 'succeededCount']);
          return item;
        }).sort((a,b)=>a["month"]-b["month"])
      : []
  )
  invoiceReport: MonthlyDashboardReports[];
  @Expose()
  @Transform(({ obj }) =>
    obj && obj.minutesReport
      ? obj.minutesReport.map((item) => {
          item['totalCount'] = item.totalMinutes;
          item['totalRetrieved'] = item.totalConsumed;
          deleteObjectProperties(item, ['totalMinutes', 'totalConsumed']);
          return item;
        }).sort((a,b)=>a["month"]-b["month"])
      : []
  )
  minutesReport: MonthlyDashboardReports[];
}
